/*
 * Maison Pattounes — Upsell « Le Suroît » du tiroir panier (robuste aux re-rendus)
 * Chargé en permanence via theme.liquid. Le snippet maison-cart-upsell est rendu
 * dans le tiroir panier, qui se re-rend via innerHTML → un <script> inline n'y
 * serait jamais ré-exécuté. On utilise donc une délégation globale (1 listener
 * stable sur document) + une mise à jour AJAX du panier (pas de reload).
 */
(function () {
  'use strict';
  if (window.__maisonSuroitUpsellBound) return;
  window.__maisonSuroitUpsellBound = true;

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var sid = el.getAttribute('data-section-id');
      if (sid && ids.indexOf(sid) === -1) ids.push(sid);
    });
    return ids;
  }

  function reopenDrawerSoon() {
    setTimeout(function () {
      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer || typeof drawer.open !== 'function') return;
      var dlg = drawer.refs && drawer.refs.dialog;
      if (dlg && dlg.open) return;
      try { drawer.open(); } catch (e) {}
    }, 250);
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest ? e.target.closest('.maison-cart-upsell__btn') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

    var root = btn.closest('.maison-cart-upsell');
    var select = root ? root.querySelector('.maison-cart-upsell__select') : null;
    var variantId = select ? select.value : btn.dataset.variantId;
    if (!variantId) return;

    var original = btn.dataset.defaultLabel || 'Ajouter';
    btn.classList.add('is-loading');
    btn.textContent = 'Ajout…';
    try {
      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', 1);
      var ids = cartSectionIds();
      if (ids.length) fd.append('sections', ids.join(','));

      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      if (!res.ok) throw new Error('add failed');
      var added = await res.json();

      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.textContent = 'Ajouté';

      var cart = null;
      try { cart = await (await fetch('/cart.js')).json(); } catch (e2) {}

      // Met à jour le tiroir + le compteur (événement Horizon), SANS recharger la page
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'maison-cart-upsell',
          data: {
            source: 'maison-cart-upsell',
            productId: (added && added.product_id) ? String(added.product_id) : undefined,
            itemCount: cart ? cart.item_count : undefined,
            variantId: String(variantId),
            sections: (added && added.sections) ? added.sections : undefined
          }
        }
      }));

      reopenDrawerSoon();

      setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = original; }, 1800);
    } catch (err) {
      console.error('Maison Suroît upsell error:', err);
      btn.classList.remove('is-loading');
      btn.textContent = original;
    }
  });

  // Changement de COULEUR dans l'upsell : repopule les tailles + met à jour image / prix / liens
  document.addEventListener('click', function (e) {
    var sw = e.target.closest ? e.target.closest('.maison-cu__swatch') : null;
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.maison-cart-upsell');
    if (!card) return;

    card.querySelectorAll('.maison-cu__swatch').forEach(function (s) { s.classList.remove('is-active'); });
    sw.classList.add('is-active');

    var sel = card.querySelector('.maison-cart-upsell__select');
    if (sel) {
      var variants = [];
      try { variants = JSON.parse(sw.dataset.variants || '[]'); } catch (e2) {}
      if (variants.length) {
        sel.innerHTML = variants.map(function (v) {
          var t = String(v.t).replace(/</g, '&lt;');
          var p = String(v.p).replace(/</g, '&lt;');
          return '<option value="' + v.id + '">' + t + ' · ' + p + '</option>';
        }).join('');
      }
    }

    var img = card.querySelector('.maison-cart-upsell__image-wrap img');
    if (img && sw.dataset.img) { img.src = sw.dataset.img; }

    var price = card.querySelector('.maison-cart-upsell__price');
    if (price && sw.dataset.price) { price.textContent = sw.dataset.price; }

    if (sw.dataset.url) {
      card.querySelectorAll('a.maison-cart-upsell__image-wrap, a.maison-cart-upsell__title').forEach(function (a) { a.href = sw.dataset.url; });
    }
  });
})();
